const prodConfig = {
  apiBaseUrl: 'https://discover.magnifi.com/api',
  oktaClientId: '0oa1m1yl1txz8Zyyn697',
  oktaIssuer: 'magnifi.okta.com'
}

export default prodConfig

// ISSUER => https://magnifi.okta.com/oauth2/default
// CLIENT ID => 0oa1m1yl1txz8Zyyn697
// Google IDP => 0oa1m1w5if9xYSwaf697
// Apple IDP => 0oa1m1z0twcMYs030697
